import { Component, Output, EventEmitter, Input, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { HttpClient } from '@angular/common/http';
import { Address } from '../../../models/address-model';

const CRAFTYCLICKS_API_URL = 'https://api.craftyclicks.co.uk/address/1.1';
const CRAFTYCLICKS_API_KEY = '15563-43abe-47d84-09c3f';

@Component({
  selector: 'app-address-search',
  standalone: true,
  imports: [CommonModule, FormsModule, AutoCompleteModule],
  templateUrl: './address-search.component.html',
  styleUrls: ['./address-search.component.css']
})
export class AddressSearchComponent {
  @Input() searchType: boolean = false;
  @Output() addressSelected = new EventEmitter<Address>();

  address: string = '';
  city: string = '';
  zip: string = '';
  suggestions: any[] = [];
  postCodesToExclude: string[] = [
        // Scottish postcodes
        "AB31","AB32","AB33","AB34","AB35","AB36","AB37","AB38","AB39","AB40","AB41","AB42","AB43","AB44","AB45","AB46","AB47","AB48","AB49","AB50","AB51","AB52","AB53","AB54","AB55","AB56",
        "FK17","FK18","FK19","FK20","FK21",
        "HS1","HS2","HS3","HS4","HS5","HS6","HS7","HS8","HS9","KA27","KA28",
        "IV1","IV2","IV3","IV4","IV5","IV6","IV7","IV8","IV9","IV10","IV11","IV12","IV13","IV14","IV15","IV16","IV17","IV18","IV19","IV20","IV21","IV22","IV23","IV24","IV25","IV26","IV27","IV28","IV29","IV30","IV31","IV32","IV33","IV34","IV35","IV36","IV37","IV38","IV39","IV40","IV41","IV42","IV43","IV44","IV45","IV46","IV47","IV48","IV49","IV50","IV51","IV52","IV53","IV54","IV55","IV56","IV57","IV58","IV59","IV60","IV61","IV62","IV63",
        "KA27","KA28",
        "KW15","KW16","KW17",
        "PA20","PA21","PA22","PA23","PA24","PA25","PA26","PA27","PA28","PA29","PA30","PA31","PA32","PA33","PA34","PA35","PA36","PA37","PA38","PA39","PA40","PA41","PA42","PA43","PA44","PA45","PA46","PA47","PA48","PA49","PA50","PA51","PA52","PA53","PA54","PA55","PA56","PA57","PA58","PA59","PA60","PA61","PA62","PA63","PA64","PA65","PA66","PA67","PA68","PA69","PA70","PA71","PA72","PA73","PA74","PA75","PA76","PA77","PA78",
        "PH15","PH16","PH17","PH18","PH19","PH20","PH21","PH22","PH23","PH24","PH25","PH26","PH27","PH28","PH29","PH30","PH31","PH32","PH33","PH34","PH35","PH36","PH37","PH38","PH39","PH40","PH41","PH42","PH43","PH44","PH45","PH46","PH47","PH48","PH49","PH50",
        "ZE1","ZE2","ZE3"
    ];

  constructor(private http: HttpClient) {}

  searchAddress(event: any) {
    //console.log(event);
    const data = {
      key: CRAFTYCLICKS_API_KEY,
      query: event,
      country: 'gbr',
      no_groupings: true,
      extra: { exclude_areas: ['gbr_northern_ireland'] }
    };

    this.http.post(`${CRAFTYCLICKS_API_URL}/find`, data).subscribe({
      next: (res: any) => {
        this.suggestions = [];
        res.results.forEach((result: any) => {
          //console.log(result);
          const postcode = result.labels[0].replace(" ", "");
          if (!this.isPostcodeExcluded(postcode) && result.labels.length > 1 && result.id.includes('address_id')) {
            this.suggestions.push({ name: result.labels[0].replace(" ", "") + ", " + result.labels[1], id: result.id });
          }
        });
      }
    });
  }

  setAddress(event: any) {
    //console.log(event);
    const data = {
      key: CRAFTYCLICKS_API_KEY,
      id: event,
      country: 'gbr',
      no_groupings: true,
      extra: { exclude_areas: ['gbr_northern_ireland'] }
    };

    this.http.post(`${CRAFTYCLICKS_API_URL}/retrieve`, data).subscribe({
      next: (res: any) => {
        this.address = res.result.line_1 + (res.result.line_2 ? ", " + res.result.line_2 : "") + (res.result.line_3 ? ", " + res.result.line_3 : "");
        this.city = res.result.locality;
        this.zip = res.result.postal_code.replace(" ", "");
        this.emitAddress();
      }
    });
  }

  private emitAddress() {
    this.addressSelected.emit({
      address: this.address,
      city: this.city,
      zip: this.zip
    });
  }

  private isPostcodeExcluded(postcode: string): boolean {
    return this.postCodesToExclude.some(prefix => postcode.toUpperCase().startsWith(prefix.toUpperCase()));
  }
}
